/**
 * SweetAlert2 헬퍼 - 단일 책임: alert/confirm 대체
 * 팝업 차단·인앱 브라우저에서도 동작하도록 네이티브 대신 SweetAlert2 사용.
 * Swal이 로드된 후에만 사용 가능 (스크립트 로드 순서 보장 필요).
 */
(function() {
  'use strict';

  function ensureSwal() {
    if (typeof window.Swal === 'undefined') {
      console.warn('SwalHelper: SweetAlert2 not loaded. Fallback to native alert/confirm.');
      return false;
    }
    return true;
  }

  /**
   * alert 대체. Promise 기반.
   * @param {string} message - 표시할 메시지
   * @param {object} [options] - Swal 옵션 (title, icon 등)
   * @returns {Promise<void>}
   */
  function alert(message, options) {
    var opts = Object.assign(
      {
        text: message,
        icon: 'info',
        confirmButtonText: 'OK'
      },
      options || {}
    );
    if (ensureSwal()) {
      return window.Swal.fire(opts);
    }
    window.alert(message);
    return Promise.resolve();
  }

  /**
   * confirm 대체. 사용자 선택에 따라 true/false로 resolve.
   * @param {string} message - 확인 메시지 (HTML 가능)
   * @param {object} [options] - Swal 옵션 (title, confirmText, cancelText 등)
   * @returns {Promise<boolean>} - 확인 시 true, 취소 시 false
   */
  function confirm(message, options) {
    var opts = Object.assign(
      {
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: options && options.confirmButtonText ? options.confirmButtonText : 'OK',
        cancelButtonText: options && options.cancelButtonText ? options.cancelButtonText : 'Cancel'
      },
      options || {}
    );
    if (ensureSwal()) {
      return window.Swal.fire(opts).then(function(result) {
        return Promise.resolve(result.isConfirmed);
      });
    }
    return Promise.resolve(window.confirm(message));
  }

  window.SwalHelper = {
    alert: alert,
    confirm: confirm
  };
})();
